'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

var _selectors = require('./selectors');

var _selectors2 = _interopRequireDefault(_selectors);

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _websockets = require('@rushplay/websockets');

var websockets = _interopRequireWildcard(_websockets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case _types2.default.CLAIM:
      return R.map(R.map(R.when(R.propEq('id', action.payload), R.assoc('claimed', true))), state);

    case websockets.SESSION_EXPIRED:
    case _types2.default.CLEAR:
      return [];

    case _types2.default.UPDATE:
      return action.payload;

    default:
      return state;
  }
}

exports.default = {
  actions: _actions2.default,
  reducer: reducer,
  selectors: _selectors2.default,
  types: _types2.default
};